import React from "react";
import './pagination.scss'
const Pagination = ({ totalPages, currentPage }) => {

  return (
    <div className="pagination">
      {Array.from({ length: totalPages }, ( l, i) => (
        <div
          key={i}
          className={`pagination-circle ${i === currentPage -1 ? "active" : ""}`}
        />
      ))}
    </div>
  );
};

export default Pagination;
